import { $http } from "@/plugins/api";
import { getApiClientUrl } from "@/config/runtimeConfig";
import type { Commit } from "vuex";
import { Organisation } from "../../types/organisatio";
import { Params } from "@/types/api";

interface State {
  list: Organisation[];
}

const state: State = {
  list: [],
};

const getters = {
  dropDownList: (state: { list: State }) => state.list,
};

const actions = {
  resetState({ commit }: { commit: Commit }) {
    commit("dropDownList", []);
  },
  async getDropDownList(
    { commit }: { commit: Commit },
    {
      globalOrganisationID,
      params,
    }: {
      globalOrganisationID: string | null;
      params: Params;
    },
  ) {
    const url = new URL(`${getApiClientUrl()}/v1/idp/orgs`);

    const reqParams = new URLSearchParams();

    if (globalOrganisationID) {
      reqParams.append("parent_uuid", globalOrganisationID);
    }

    // Convert params to lowercase strings and append them to reqParams
    for (const [key, value] of Object.entries(params)) {
      reqParams.append(key, value.toString());
    }

    url.search = reqParams.toString();

    const orgsResponse = await $http.get(url.toString());

    commit("dropDownList", orgsResponse.data.data);
  },
};

const mutations = {
  dropDownList: (state: { list: Organisation }, list: Organisation) =>
    (state.list = list),
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
